import React from 'react';

// Orijinal HTML'deki 'services' bölümünün React component'i
function Hizmetler() {
  return (
    // section'a ID veriyoruz ki Navbar'dan link verilebilsin
    <section className="section services" id="hizmetler">
      <div className="container">
        <h2 className="section-title">Hizmetlerimiz</h2>
        <div className="services-grid">
          
          <div className="service-card">
            <div className="service-icon">🏗️</div>
            <h3>Konut İnşaatı</h3>
            <p>Modern ve konforlu yaşam alanları için güvenli konut projeleri tasarlıyor ve inşa ediyoruz.</p>
          </div>

          <div className="service-card">
            <div className="service-icon">🏢</div>
            <h3>Ticari Yapılar</h3>
            <p>İş yeriniz için fonksiyonel ve estetik ticari binalar yapıyoruz. Ofis, mağaza ve fabrika projeleri.</p>
          </div>

          <div className="service-card">
            <div className="service-icon">🛣️</div>
            <h3>Altyapı Çalışmaları</h3>
            <p>Yol, köprü, kanal ve diğer altyapı projelerinde uzman ekibimizle hizmet veriyoruz.</p>
          </div>

          <div className="service-card">
            <div className="service-icon">🔧</div>
            <h3>Tadilat & Renovasyon</h3>
            <p>Mevcut yapılarınızı modern standartlara taşıyor, yenileme ve güçlendirme işlemleri yapıyoruz.</p>
          </div>

        </div>
      </div>
    </section>
  );
}

export default Hizmetler;